<template>
  <div class="goal-item" :class="{ '--finished': projectFinished }">
    <div class="goal-item__left">
      <span class="goal-item__icon" :class="{ finished: isFinished }">
        <svgo-goal-check v-if="isFinished" class="icon" />
      </span>
      <span v-if="index !== goals.length - 1" class="goal-item__line">
        <span
          class="goal-item__active-line"
          :style="{ height: `${activeLineHeight}%` }"
        />
      </span>
    </div>
    <div class="goal-item__right">
      <div
        class="goal-item__name"
        :class="{ active: isFinished || isActiveGoal }"
      >
        {{ goalName }}
        <svgo-lock v-if="!isFinished && !isActiveGoal" class="icon-lock" />
      </div>
      <div class="goal-item__info">
        {{ goal.name }}
      </div>
    </div>
  </div>
</template>

<script setup>
const { $t } = useI18n();

const props = defineProps({
  goals: { type: Array, required: true },
  goal: { type: Object, required: true },
  index: { type: Number, required: true },
  locale: { type: String, default: 'en' },
  projectFinished: { type: Boolean, default: false },
});

const isFinished = computed(() => props.goal.state === 'finished');
const isActiveGoal = computed(() => props.goal.state === 'active');

const goalTarget = computed(() => {
  return [...props.goals]
    .slice(0, props.index)
    .reduce((target, goal) => target + goal.target, props.goal.target);
});

const goalName = computed(() => {
  return `${$t('donate.goal')} ${props.index + 1}: $${getSum(
    goalTarget.value
  )}`;
});

const activeLineHeight = computed(() => {
  return (
    (props.goals[props.index + 1]?.current * 100) /
    props.goals[props.index + 1]?.target
  );
});

function getSum(sumWithCents) {
  const cents = sumWithCents?.toString().slice(-2);
  const sum = sumWithCents?.toString().slice(0, -2);
  return sumWithCents
    ? Number(`${sum}.${cents}`).toLocaleString(props.locale)
    : 0;
}
</script>

<style lang="scss">
@use '@styles/components/pages/project/goalsModalItem.scss' as *;
</style>
